









































































































import { CopyUrl } from "@/common/clipboard";
import Vue from "vue";
import { ScanSessionStatus } from "../../data/model";
import { SourceStartParams } from "@/views/customize/data-sources/data/data-relations/start-params.map";
import { Filters } from "@/common/filters.global";
export default Vue.extend({
  props: ["session", "hide_actions", "is_selected", "has_session_params"],
  filters: {
    session_status(status: ScanSessionStatus) {
      switch (status) {
        case "Opened":
          return "Running";
        case "Closed":
          return "Completed";
        case "Cancelled":
          return "Cancelled";
      }
    },
    config_keys(key: string) {
      return SourceStartParams[key] ? SourceStartParams[key].display_name : key;
    },
    param_value(value: string, key: string) {
      switch (key) {
        case "scanSizeLimit":
          return Filters.nums_with_commas(+value);
        case "scanPaths":
          return value == "[]"
            ? "all"
            : value.replace("[", "").replace("]", "");
        default:
          return value;
      }
    },
  },
  setup() {
    const copy_value = (key: string, val: string) => {
      const normalized_val = val
        .replace("[", "")
        .replace("]", "")
        .replace('"', "");
      CopyUrl(normalized_val, `${key} copied to clipboard`);
    };

    const copy_session_params = (params: Record<string, any>) => {
      CopyUrl(JSON.stringify(params), `session params copied to clipboard`);
    };
    return { copy_value, SourceStartParams, copy_session_params };
  },
});
